/**
 * Machine-readable `code` on the 401 problem body returned by the MFA login
 * endpoints (verify-totp, verify-recovery-code, passkey verify).
 *
 * - `mfa_code_invalid` — the code was wrong. The MFA token is still good, so
 *   the client stays on the challenge page and lets the user try again.
 * - `mfa_token_invalid` — the MFA token is expired, already used, or forged.
 *   The client sends the user back to /login.
 * - `mfa_too_many_attempts` — the user hit the per-token try limit. The token
 *   is now burned, so the client sends the user back to /login.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MFA_LOGIN_ERROR_CODES () {
        return MFA_LOGIN_ERROR_CODES;
    },
    get MFA_LOGIN_MAX_ATTEMPTS () {
        return MFA_LOGIN_MAX_ATTEMPTS;
    }
});
const MFA_LOGIN_ERROR_CODES = {
    codeInvalid: 'mfa_code_invalid',
    tokenInvalid: 'mfa_token_invalid',
    tooManyAttempts: 'mfa_too_many_attempts'
};
const MFA_LOGIN_MAX_ATTEMPTS = 5;
